"use strict";
var React = require("react");
var AddBrandModal = require("./AddBrandModal");
var EditBrandModal = require("./EditBrandModal");
var DeleteBrandModal = require("./DeleteBrandModal");
var CompanyStore = require("../../../stores/CompanyStore");
var Button = require("react-bootstrap").Button;
var _ = require("underscore");
var clone = require("clone");

var BrandsTab = React.createClass({
  getInitialState: function(){
    var storeState = CompanyStore.getState();
    var brands = storeState.brands;

    return {
      brands: brands,
      showModal: false,
      showEditModal: false,
      showDeleteModal: false,
      brand: {},
    };
  },
  componentDidMount: function() {
    CompanyStore.listen(this.onChange);
  },
  componentWillUnmount: function() {
    CompanyStore.unlisten(this.onChange);
  },
  onChange: function() {
    this.setState(this.getInitialState());
  },
  closeAdd (){
    this.setState({ showModal: false });
  },
  openAdd () {
    this.setState({ showModal: true });
  },
  close() {
    this.setState({ showEditModal: false });
  },
  open(brand) {
    this.setState({
      brand: brand,
      showEditModal: true,
    });
  },
  closeDelete() {
    this.setState({ showDeleteModal: false });
  },
  openDelete(brand) {
    this.setState({
      brand: brand,
      showDeleteModal: true,
    });
  },
  mapIcons: function(brand) {
    return (
      <li key={brand.id}>
        <div className="tree-item">
          <div className="tree-item-name">{brand && brand.name}</div>
          <div className="tree-item-buttons">
            <button className="tree-button" type="button" title="Breyta" onClick={() => this.open(brand)}>
              <span className="md md-mode-edit"/>
            </button>
            <button className="tree-button" type="button" title="Eyða" onClick={() => this.openDelete(brand)}>
              <span className="md md-delete"/>
            </button>
          </div>
        </div>
      </li>
    );
  },
  render: function() {
    return (
      <div className="row">
        <EditBrandModal brand={this.state.brand} show={this.state.showEditModal} onHide={this.close} />
        <DeleteBrandModal brand={this.state.brand} show={this.state.showDeleteModal} onHide={this.closeDelete} />
        <div className="settings-header col-xs-12">
          <h3>Vörumerki</h3>
          <AddBrandModal show={this.state.showModal} onHide={this.closeAdd} />
          <Button className="page-scroll btn btn-xl" onClick={this.openAdd}>Bæta við vörumerki</Button>
        </div>
        <div className="settings-body col-xs-12">
          <div className="row">
            <div className="tree-list">
              <ul className="first-ul">
                {this.state.brands.map((brand) => {
                  return this.mapIcons(brand);
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
});

module.exports = BrandsTab;



// WEBPACK FOOTER //
// ./app/scripts/ui/Settings/Brands/BrandsTab.react.js